import { useEffect } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";
import { openMessage } from "utils/misc.tsx";
import { getRequestErrorMessage } from "features/finance/utils";

const useRequestErrorMessage = (isError: boolean, error: unknown) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ADMIN);
  useEffect(() => {
    if (isError)
      openMessage(
        getRequestErrorMessage(error) ?? t("finance.load_failed"),
        "error"
      );
  }, [isError, error, t]);
};

export default useRequestErrorMessage;
